import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { Privacy } from '@/components/blocks/Document/Privacy'
import { Layout } from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

const PrivacyPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      seo={{
        title: 'Privacy Policy | Nutria',
        description: t('cl_landing_privacy_policy_meta_description'),
      }}
    >
      <Privacy />
    </Layout>
  )
}

export default PrivacyPage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
